<template>
  <div class="page-container">
    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <Header :menuVisible="menuVisible" v-on:toggleMenu="toggleMenu"/>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <Menu :menuVisible="menuVisible"/>
      </md-app-drawer>

      <md-app-content>
        <div>
            <md-dialog :md-active.sync="showDialog" style="overflow: scroll">
                <md-dialog-title>Detalles</md-dialog-title>

                <md-list class="md-double-line">
                    <md-subheader>Cuenta</md-subheader>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Identificador único:</span>
                            <span>{{selectedPlayer.id}}</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Nombre:</span>
                            <span>{{selectedPlayer.name}}</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Email:</span>
                            <span>{{selectedPlayer.email}} <span class="md-caption" v-if="selectedPlayer.emailVerified">(Verificado)</span></span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset" v-if="selectedPlayer.group">
                        <div class="md-list-item-text">
                            <span>Grupo:</span>
                            <span>{{schools[selectedPlayer.group].name}}</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Creación:</span>
                            <span>{{selectedPlayer.createdAt | formatDate}}</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Última modificación:</span>
                            <span>{{selectedPlayer.updatedAt | formatDate}}</span>
                        </div>
                    </md-list-item>

                    <md-subheader>Estadísticas</md-subheader>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Juegos terminados:</span>
                            <span>{{selectedPlayer.stats.games}} juegos.</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Cantidad de monedas ganadas:</span>
                            <span>{{selectedPlayer.stats.coins}} monedas.</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Cantidad de monedas disputadas:</span>
                            <span>{{selectedPlayer.stats.coinsTotal}} monedas.</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Tiempo promedio por juego:</span>
                            <span>{{selectedPlayer.stats.avgGameTime / 1000}} segundos.</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Juego más rápido:</span>
                            <span>{{selectedPlayer.stats.fastestGame / 1000}} segundos.</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Juego más lento:</span>
                            <span>{{selectedPlayer.stats.slowestGame / 1000}} segundos.</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Mejor porcentaje de monedas ganadas en un juego:</span>
                            <span>{{selectedPlayer.stats.bestCoinsWonPct}}%</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Mejor porcentaje de aciertos en un juego:</span>
                            <span>{{selectedPlayer.stats.bestOkPct}}%</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Peor porcentaje de aciertos en un juego:</span>
                            <span>{{selectedPlayer.stats.worstOkPct}}%</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Peor porcentaje de monedas ganadas en un juego:</span>
                            <span>{{selectedPlayer.stats.worstCoinsWonPct}}%</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Preguntas respondidas:</span>
                            <span>{{selectedPlayer.stats.questions}} preguntas.</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Respuestas correctas:</span>
                            <span>{{selectedPlayer.stats.questionsOk}} respuestas.</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Respuestas incorrectas:</span>
                            <span>{{selectedPlayer.stats.questionsError}} respuestas.</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Tiempo promedio por pregunta:</span>
                            <span>{{selectedPlayer.stats.avgQuestionTime / 1000}} segundos.</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Pregunta más rápida:</span>
                            <span>{{selectedPlayer.stats.fastestQuestion / 1000}} segundos.</span>
                        </div>
                    </md-list-item>
                    <md-list-item class="md-inset">
                        <div class="md-list-item-text">
                            <span>Pregunta más lenta:</span>
                            <span>{{selectedPlayer.stats.slowestQuestion / 1000}} segundos.</span>
                        </div>
                    </md-list-item>
                </md-list>

                <md-dialog-actions>
                    <md-button class="md-accent" @click="showDialog = false">Cerrar</md-button>
                </md-dialog-actions>
            </md-dialog>

            <md-table v-model="players" md-sort="name" md-sort-order="asc" md-card md-fixed-header>
                <md-table-toolbar>
                    <h1 class="md-title">Jugadores <span>(Total: <strong>{{ stats.playersCount }}</strong>)</span></h1>

                    <md-content class="text-xs-center" v-if="loading">
                        <p class="md-subheading md-layout md-alignment-top-center" v-bind:style="{ width: '100%' }">Cargando...</p>
                    </md-content>
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }" v-if="!loading">
                    <md-table-cell md-label="ID" md-sort-by="id">{{ item.id }}</md-table-cell>
                    <md-table-cell md-label="Nombre" md-sort-by="name">{{ item.name }}</md-table-cell>
                    <md-table-cell md-label="Email" md-sort-by="email">
                        {{ item.email }}
                        <span class="md-caption" v-if="item.emailVerified">(Verificado)</span>
                    </md-table-cell>
                    <md-table-cell md-label="Creación" md-sort-by="createdAt">{{ item.createdAt | formatDate }}</md-table-cell>
                    <md-table-cell class="actions-cell">
                        <md-button class="md-icon-button md-primary" @click="viewItem(item)">
                            <md-icon>pageview</md-icon>
                        </md-button>
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </div>
      </md-app-content>
    </md-app>
  </div>
</template>

<style lang="scss" scoped>
  .md-app {
    border: 1px solid rgba(#000, .12);
  }
  .md-dialog {
    max-width: 768px;
  }
  .actions-cell {
    text-align: right;
  }
  .md-list {
    max-width: 100%;
    overflow-y: scroll;
    vertical-align: top;
  }
</style>

<script>
import Header from './Header.vue';
import Menu from './Menu.vue';
import firebase from 'firebase';
import {config} from '../helpers/apiConfig'
import {user} from '../helpers/user'
import axios from "axios";

export default {
    name: 'Users',
    components: {
        Header, Menu
    },
    data: () => ({
        menuVisible: false,
        showDialog: false,
        loading: false,
        players: [],
        schools: {},
        stats: {},
        selectedPlayer: {
            stats: {}
        }
    }),
    mounted() {
        firebase.auth().onAuthStateChanged((liuser) => {
            if (liuser) {
                console.log('User logged in, go ahead...');
                var that = this;
                user.init(firebase.auth().currentUser, () => {
                    that.fetchData();
                });
            } else {
                this.$router.push('/auth')
                console.log('User not logged in!');
            }
        });
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        toggleMenu () {
            this.menuVisible = !this.menuVisible
        },
        fetchData () {
            this.players = [];
            this.loading = true;

            axios({ 
                "method": "GET", 
                "url": config.apiUrl + "/player", 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    this.loading = false;
                    this.players = result.data;
                }, error => {
                    console.error(error);
                    this.loading = false;
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );

            axios({ 
                "method": "GET", 
                "url": config.apiUrl + "/school", 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    if (typeof result.data == 'object' && result.data.length > 0) {
                        var that = this;
                        result.data.forEach(s => {
                            that.schools[s.id] = s;
                        });
                    }
                }, error => {
                    console.error(error);
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );

            axios({ 
                "method": "GET", 
                "url": config.apiUrl + "/stats", 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    this.stats = result.data;
                }, error => {
                    console.error(error);
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );
        },
        viewItem (item) {
            console.log(item);
            this.showDialog = !this.showDialog;
            this.selectedPlayer = item;
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Players.vue